// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2FdNz","options":"AnswerScale_options__2yEFN","selected":"AnswerScale_selected__3ecGN"};